(function () {
  'use strict';

  var drawer = document.querySelector('[data-mb-search-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.mb-search-drawer__panel');
  var openButtons = document.querySelectorAll('[data-mb-search-open]');
  var closeButtons = drawer.querySelectorAll('[data-mb-search-close]');
  var form = drawer.querySelector('[data-mb-search-form]');
  var input = drawer.querySelector('#mb-search-drawer-input');
  var resetBtn = drawer.querySelector('[data-mb-search-reset]');
  var fullResults = drawer.querySelector('[data-mb-search-full-results]');
  var predictive = drawer.querySelector('predictive-search');
  var lastFocus = null;
  var closeTimer = null;
  var isClosing = false;

  function searchUrl() {
    return (window.routes && window.routes.search_url) || '/search';
  }

  function isOpen() {
    return drawer.classList.contains('is-open');
  }

  function setOpenButtonsActive(active) {
    openButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
    });
  }

  function toggleReset() {
    if (!resetBtn || !input) return;
    resetBtn.classList.toggle('hidden', input.value.length === 0);
  }

  function clearFullResults() {
    if (!fullResults) return;
    fullResults.hidden = true;
    fullResults.innerHTML = '';
  }

  function cancelClose() {
    isClosing = false;
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function openDrawer() {
    if (isOpen()) return;

    cancelClose();

    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');

    /* Force layout so the slide-in transition runs after [hidden] is removed */
    void drawer.offsetHeight;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        document.documentElement.classList.add('mb-search-open');
        setOpenButtonsActive(true);
      });
    });

    window.setTimeout(function () {
      if (!isOpen() || !input) return;
      input.focus({ preventScroll: true });
      if (typeof input.select === 'function') input.select();
    }, 120);
  }

  function finishClose() {
    if (!isClosing) return;

    isClosing = false;
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mb-search-open');
    setOpenButtonsActive(false);
    clearFullResults();

    if (input) input.value = '';
    toggleReset();

    if (predictive && typeof predictive.close === 'function') {
      predictive.close(true);
    }

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function closeDrawer() {
    if (!isOpen() || isClosing) return;

    isClosing = true;
    drawer.classList.remove('is-open');
    setOpenButtonsActive(false);

    var finished = false;

    function completeClose() {
      if (finished) return;
      finished = true;
      if (panel) panel.removeEventListener('transitionend', onTransitionEnd);
      finishClose();
    }

    function onTransitionEnd(event) {
      if (!panel || event.target !== panel) return;
      if (event.propertyName !== 'transform') return;
      completeClose();
    }

    if (panel) panel.addEventListener('transitionend', onTransitionEnd);
    closeTimer = window.setTimeout(completeClose, 400);
  }

  function loadFullResults(query) {
    if (!query || !fullResults) return;

    fullResults.hidden = false;
    fullResults.innerHTML = '<p class="mb-search-drawer__loading">' + (drawer.dataset.loadingText || 'Loading…') + '</p>';

    if (predictive && typeof predictive.close === 'function') {
      predictive.close(true);
    }

    var url = searchUrl()
      + '?q=' + encodeURIComponent(query)
      + '&options%5Bprefix%5D=last'
      + '&section_id=mb-search-drawer-results';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('#shopify-section-mb-search-drawer-results');
        fullResults.innerHTML = section ? section.innerHTML : '<p class="mb-search-drawer__empty">No results found.</p>';
        fullResults.scrollIntoView({ block: 'nearest' });
      })
      .catch(function () {
        fullResults.innerHTML = '<p class="mb-search-drawer__empty">Unable to load results. Please try again.</p>';
      });
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (isOpen()) closeDrawer();
      else openDrawer();
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      closeDrawer();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) {
      event.preventDefault();
      closeDrawer();
    }
  });

  if (input) {
    input.addEventListener('input', function () {
      toggleReset();
      if (input.value.trim() === '') clearFullResults();
    });
  }

  if (resetBtn && form) {
    resetBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (input) input.value = '';
      form.dispatchEvent(new Event('reset', { bubbles: true }));
      clearFullResults();
      toggleReset();
      if (predictive && typeof predictive.close === 'function') predictive.close(true);
      if (input) input.focus({ preventScroll: true });
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input ? input.value.trim() : '';
      if (!query) return;

      if (predictive) {
        var selected = predictive.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        if (selected) {
          if (selected.tagName === 'A') {
            window.location.href = selected.href;
          } else {
            selected.click();
          }
          return;
        }
      }

      loadFullResults(query);
    });
  }

  drawer.addEventListener('click', function (event) {
    var termBtn = event.target.closest('.predictive-search__item--term');
    if (!termBtn) return;
    event.preventDefault();
    var query = input ? input.value.trim() : '';
    if (query) loadFullResults(query);
  });

  drawer.addEventListener('click', function (event) {
    var link = event.target.closest('.mb-search-drawer__full a[href]');
    if (link) closeDrawer();
  });
})();
